// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import List from './TargetingSources/List'
import Selector from './TargetingSources/Selector'
import { translateFunc } from '../shared/localize'
import translations from '../shared/translations.ru'
import Modal from 'react-responsive-modal'
import AjaxLink from './AjaxLink'
import styled, { type StyledComponent } from 'styled-components'
import SegmentMenu from './TargetingSources/SegmentMenu'
import { MenuItem } from '../components/MainTable'
import Button from './controls/PrimaryButton'
import type {
  OptionType,
  Segment,
  Contact,
  Lookalike,
  ProviderIcons,
  ProviderTargetingSource
} from './types'
import ErrorText from './controls/ErrorText'
import SegmentForm from './TargetingSources/SegmentForm'
import ContactForm from './TargetingSources/ContactForm'
import LookalikeForm from './TargetingSources/LookalikeForm'

const StyledAjaxLink: any = styled(AjaxLink)`
  text-decoration: none;
`
const StyledMenuItem: StyledComponent<Object, any, any> = (styled(MenuItem)`
  font-size: 13px;
`: any)

const TargetingSourcesWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flew-wrap: wrap;
  margin-left: -10px;
`
const TargetingSourceWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-left: 10px;
`
const MenuWrapper: StyledComponent<Object, any, any> = styled.div`
  text-align: left;
`

type Props = {|
  contactTypeTranslations: Object,
  segments: Array<Segment>,
  contacts: Array<Contact>,
  lookalikeSegments: Array<Lookalike>,
  lookalikeContacts: Array<Lookalike>,
  providerTargetingSources: Array<ProviderTargetingSource>,
  includedSegmentIds: Array<number>,
  excludedSegmentIds: Array<number>,
  includedContactIds: Array<number>,
  excludedContactIds: Array<number>,
  includedLookalikeSegmentIds: Array<number>,
  includedLookalikeContactIds: Array<number>,
  includedProviderTargetingSourceIds: Array<number>,
  excludedProviderTargetingSourceIds: Array<number>,
  countries: Array<OptionType>,
  defaultCountryId: number,
  includedSegmentIdsErrors: Array<string>,
  includedContactIdsErrors: Array<string>,
  excludedSegmentIdsErrors: Array<string>,
  excludedContactIdsErrors: Array<string>,
  includedLookalikeSegmentIdsErrors: Array<string>,
  includedLookalikeContactIdsErrors: Array<string>,
  includedProviderTargetingSourceIdsErrors: Array<string>,
  excludedProviderTargetingSourceIdsErrors: Array<string>,
  icons: ProviderIcons,
  onChange: Function,
  onImportProviderTargetingSources: Function
|}

type State = {|
  isMenuOpen: boolean,
  isSegmentPopupOpen: boolean,
  isContactPopupOpen: boolean,
  isModalOpen: boolean,
  isLookalikeModalOpen: boolean
|}

const lookalikeSegmentType = 'lookalike_segment'
const lookalikeContactType = 'lookalike_contact'

const t = translateFunc({ ...translations.targeting_sources, ...translations.lookalike_form })
export default class TargetingSources extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isMenuOpen: false,
      isSegmentPopupOpen: false,
      isContactPopupOpen: false,
      isModalOpen: false,
      isLookalikeModalOpen: false
    }
  }

  render() {
    const {
      isMenuOpen,
      isSegmentPopupOpen,
      isContactPopupOpen,
      isModalOpen,
      isLookalikeModalOpen
    } = this.state
    const {
      segments,
      contacts,
      lookalikeSegments,
      lookalikeContacts,
      providerTargetingSources,
      includedSegmentIds,
      excludedSegmentIds,
      includedContactIds,
      excludedContactIds,
      includedLookalikeSegmentIds,
      includedLookalikeContactIds,
      includedProviderTargetingSourceIds,
      excludedProviderTargetingSourceIds,
      countries,
      defaultCountryId,
      icons
    } = this.props

    const { contactTypeTranslations } = this.props
    return (
      <div>
        <Modal open={isModalOpen} onClose={() => this.setState({ isModalOpen: false })}>
          <Selector
            translations={_.extend({}, translations.targeting_sources, {
              contact_types: contactTypeTranslations
            })}
            onClose={() => this.setState({ isModalOpen: false })}
            segments={segments}
            contacts={contacts}
            lookalikeSegments={lookalikeSegments}
            lookalikeContacts={lookalikeContacts}
            providerTargetingSources={providerTargetingSources}
            includedSegmentIds={includedSegmentIds}
            excludedSegmentIds={excludedSegmentIds}
            includedContactIds={includedContactIds}
            excludedContactIds={excludedContactIds}
            includedLookalikeSegmentIds={includedLookalikeSegmentIds}
            includedLookalikeContactIds={includedLookalikeContactIds}
            includedProviderTargetingSourceIds={includedProviderTargetingSourceIds}
            excludedProviderTargetingSourceIds={excludedProviderTargetingSourceIds}
            onIncludedSegmentRemove={(id) => this.removeFromIncludedSegments(id)}
            onExcludedSegmentRemove={(id) => this.removeFromExcludedSegments(id)}
            onIncludedContactRemove={(id) => this.removeFromIncludedContacts(id)}
            onExcludedContactRemove={(id) => this.removeFromExcludedContacts(id)}
            onIncludedLookalikeSegmentRemove={(id) => this.removeFromIncludedLookalikeSegments(id)}
            onIncludedLookalikeContactRemove={(id) => this.removeFromIncludedLookalikeContacts(id)}
            onIncludedProviderTargetingSourceRemove={(id) =>
              this.removeFromIncludedProviderTargetingSources(id)
            }
            onExcludedProviderTargetingSourceRemove={(id) =>
              this.removeFromExcludedProviderTargetingSources(id)
            }
            onIncludedSegmentAdd={(id) => this.addToIncludedSegments(id)}
            onExcludedSegmentAdd={(id) => this.addToExcludedSegments(id)}
            onIncludedContactAdd={(id) => this.addToIncludedContacts(id)}
            onExcludedContactAdd={(id) => this.addToExcludedContacts(id)}
            onIncludedLookalikeSegmentAdd={(id) => this.addToIncludedLookalikeSegments(id)}
            onIncludedLookalikeContactAdd={(id) => this.addToIncludedLookalikeContacts(id)}
            onIncludedProviderTargetingSourceAdd={(id) =>
              this.addToIncludedProviderTargetingSources(id)
            }
            onExcludedProviderTargetingSourceAdd={(id) =>
              this.addToExcludedProviderTargetingSources(id)
            }
            icons={icons}
          />
        </Modal>
        <List
          segments={segments}
          contacts={contacts}
          lookalikeSegments={lookalikeSegments}
          lookalikeContacts={lookalikeContacts}
          providerTargetingSources={providerTargetingSources}
          includedSegmentIds={includedSegmentIds}
          excludedSegmentIds={excludedSegmentIds}
          includedContactIds={includedContactIds}
          excludedContactIds={excludedContactIds}
          includedLookalikeSegmentIds={includedLookalikeSegmentIds}
          includedLookalikeContactIds={includedLookalikeContactIds}
          includedProviderTargetingSourceIds={includedProviderTargetingSourceIds}
          excludedProviderTargetingSourceIds={excludedProviderTargetingSourceIds}
          onIncludedSegmentRemove={(id) => this.removeFromIncludedSegments(id)}
          onExcludedSegmentRemove={(id) => this.removeFromExcludedSegments(id)}
          onIncludedContactRemove={(id) => this.removeFromIncludedContacts(id)}
          onExcludedContactRemove={(id) => this.removeFromExcludedContacts(id)}
          onIncludedLookalikeSegmentRemove={(id) => this.removeFromIncludedLookalikeSegments(id)}
          onIncludedLookalikeContactRemove={(id) => this.removeFromIncludedLookalikeContacts(id)}
          onIncludedProviderTargetingSourceRemove={(id) =>
            this.removeFromIncludedProviderTargetingSources(id)
          }
          onExcludedProviderTargetingSourceRemove={(id) =>
            this.removeFromExcludedProviderTargetingSources(id)
          }
        />
        <Modal
          open={isLookalikeModalOpen}
          onClose={() => this.setState({ isLookalikeModalOpen: false })}
        >
          <LookalikeForm
            onClose={() => this.setState({ isLookalikeModalOpen: false })}
            origins={this.buildOriginOptions()}
            countries={countries}
            defaultCountryId={defaultCountryId}
            onObjectCreated={(response) => this.onLookalikeResponse(response)}
          />
        </Modal>
        <Modal
          open={isSegmentPopupOpen}
          onClose={() => this.setState({ isSegmentPopupOpen: false })}
        >
          <SegmentForm
            onClose={() => this.setState({ isSegmentPopupOpen: false })}
            onObjectCreated={(response) => this.onSegmentResponse(response)}
          />
        </Modal>
        <Modal
          open={isContactPopupOpen}
          onClose={() => this.setState({ isContactPopupOpen: false })}
        >
          <ContactForm
            onClose={() => this.setState({ isContactPopupOpen: false })}
            onObjectCreated={(response) => this.onContactResponse(response)}
          />
        </Modal>
        <TargetingSourcesWrapper>
          {(!_.isEmpty(segments) ||
            !_.isEmpty(contacts) ||
            !_.isEmpty(lookalikeSegments) ||
            !_.isEmpty(lookalikeContacts) ||
            !_.isEmpty(providerTargetingSources)) && (
            <TargetingSourceWrapper>
              <Button
                small
                onClick={(event) => {
                  event.preventDefault()
                  this.setState({ isModalOpen: true })
                }}
              >
                {t('choose_from_created')}
              </Button>
            </TargetingSourceWrapper>
          )}
          <TargetingSourceWrapper>
            <SegmentMenu
              isOpen={this.state.isMenuOpen}
              onClick={() => this.setState({ isMenuOpen: !isMenuOpen })}
              onClose={() => this.setState({ isMenuOpen: false })}
            >
              {this.renderDropdownContent()}
            </SegmentMenu>
          </TargetingSourceWrapper>
        </TargetingSourcesWrapper>
        <ErrorText
          errors={[
            ...this.props.includedSegmentIdsErrors,
            ...this.props.includedContactIdsErrors,
            ...this.props.excludedSegmentIdsErrors,
            ...this.props.excludedContactIdsErrors,
            ...this.props.includedLookalikeSegmentIdsErrors,
            ...this.props.includedLookalikeContactIdsErrors,
            ...this.props.includedProviderTargetingSourceIdsErrors,
            ...this.props.excludedProviderTargetingSourceIdsErrors
          ]}
        />
      </div>
    )
  }

  renderDropdownContent() {
    return (
      <MenuWrapper>
        <StyledAjaxLink
          onClick={() => {
            this.setState({ isMenuOpen: false })
            this.setState({ isSegmentPopupOpen: true })
          }}
        >
          <StyledMenuItem>{t('new_segment')}</StyledMenuItem>
        </StyledAjaxLink>
        <StyledAjaxLink
          onClick={() => {
            this.setState({ isMenuOpen: false })
            this.setState({ isContactPopupOpen: true })
          }}
        >
          <StyledMenuItem>{t('new_contact_list')}</StyledMenuItem>
        </StyledAjaxLink>
        <StyledMenuItem
          onClick={() => {
            this.setState({ isMenuOpen: false })
            this.setState({ isLookalikeModalOpen: true })
          }}
        >
          {t('new_lookalike')}
        </StyledMenuItem>
        {_.map(['vk', 'target_mail', 'facebook'], (provider: string) => {
          return (
            <StyledMenuItem
              key={provider}
              onClick={() => {
                this.setState({ isMenuOpen: false })
                this.props.onImportProviderTargetingSources(provider)
              }}
            >
              {t(`import_targeting_sources.${provider}`)}
            </StyledMenuItem>
          )
        })}
      </MenuWrapper>
    )
  }

  removeFromIncludedSegments(id: number) {
    this.changed({ includedSegmentIds: _.without(this.props.includedSegmentIds, id) })
  }

  removeFromExcludedSegments(id: number) {
    this.changed({ excludedSegmentIds: _.without(this.props.excludedSegmentIds, id) })
  }

  removeFromIncludedContacts(id: number) {
    this.changed({ includedContactIds: _.without(this.props.includedContactIds, id) })
  }

  removeFromExcludedContacts(id: number) {
    this.changed({ excludedContactIds: _.without(this.props.excludedContactIds, id) })
  }

  removeFromIncludedLookalikeSegments(id: number) {
    this.changed({
      includedLookalikeSegmentIds: _.without(this.props.includedLookalikeSegmentIds, id)
    })
  }

  removeFromIncludedLookalikeContacts(id: number) {
    this.changed({
      includedLookalikeContactIds: _.without(this.props.includedLookalikeContactIds, id)
    })
  }

  removeFromIncludedProviderTargetingSources(id: number) {
    this.changed({
      includedProviderTargetingSourceIds: _.without(
        this.props.includedProviderTargetingSourceIds,
        id
      )
    })
  }

  removeFromExcludedProviderTargetingSources(id: number) {
    this.changed({
      excludedProviderTargetingSourceIds: _.without(
        this.props.excludedProviderTargetingSourceIds,
        id
      )
    })
  }

  addToIncludedSegments(id: number) {
    this.changed({ includedSegmentIds: _.uniq(_.concat(this.props.includedSegmentIds, id)) })
  }

  addToExcludedSegments(id: number) {
    this.changed({ excludedSegmentIds: _.uniq(_.concat(this.props.excludedSegmentIds, id)) })
  }

  addToIncludedContacts(id: number) {
    this.changed({ includedContactIds: _.uniq(_.concat(this.props.includedContactIds, id)) })
  }

  addToExcludedContacts(id: number) {
    this.changed({ excludedContactIds: _.uniq(_.concat(this.props.excludedContactIds, id)) })
  }

  addToIncludedLookalikeSegments(id: number) {
    this.changed({
      includedLookalikeSegmentIds: _.uniq(_.concat(this.props.includedLookalikeSegmentIds, id))
    })
  }

  addToIncludedLookalikeContacts(id: number) {
    this.changed({
      includedLookalikeContactIds: _.uniq(_.concat(this.props.includedLookalikeContactIds, id))
    })
  }

  addToIncludedProviderTargetingSources(id: number) {
    this.changed({
      includedProviderTargetingSourceIds: _.uniq(
        _.concat(this.props.includedProviderTargetingSourceIds, id)
      )
    })
  }

  addToExcludedProviderTargetingSources(id: number) {
    this.changed({
      excludedProviderTargetingSourceIds: _.uniq(
        _.concat(this.props.excludedProviderTargetingSourceIds, id)
      )
    })
  }

  onSegmentResponse(segment: Segment) {
    let segments = _.sortBy([...this.props.segments, segment], 'id')
    this.changed({ segments })
  }

  onContactResponse(contact: Contact) {
    let contacts = _.sortBy([...this.props.contacts, contact], 'id')
    this.changed({ contacts })
  }

  onLookalikeResponse(lookalike: Object) {
    if (lookalike.origin_type === 'segment') {
      let lookalikeSegments = _.sortBy([...this.props.lookalikeSegments, lookalike], 'id')
      this.changed({ lookalikeSegments })
    } else if (lookalike.origin_type === 'contact') {
      let lookalikeContacts = _.sortBy([...this.props.lookalikeContacts, lookalike], 'id')
      this.changed({ lookalikeContacts })
    }
  }

  changed(diff: Object) {
    this.props.onChange(diff)
  }

  buildOriginOptions() {
    const { segments, contacts } = this.props
    let segmentOptions = this.buildOptions(segments, lookalikeSegmentType)
    let contactOptions = this.buildOptions(contacts, lookalikeContactType)
    return [...segmentOptions, ...contactOptions]
  }

  buildOptions(origins: Array<Segment> | Array<Contact>, originType: string): Array<Object> {
    return _.map(origins, (origin) => {
      return {
        name: origin.name,
        id: origin.id,
        type: originType
      }
    })
  }
}
